import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

const PartyColorContext = createContext();

export const usePartyColors = () => {
  const context = useContext(PartyColorContext);
  if (!context) {
    throw new Error('usePartyColors must be used within a PartyColorProvider');
  }
  return context;
};

export const PartyColorProvider = ({ children }) => {
  const [partyColors, setPartyColors] = useState({});


  // Helper to normalise party keys
  const normaliseKey = (party) => party?.trim().toUpperCase() || '';

  useEffect(() => {
    const fetchColors = async () => {
      console.log('Fetching party colors from Supabase...');

      const { data, error } = await supabase
        .from('party_colors')
        .select('party, color');

      if (error) {
        console.error('Error fetching party colors:', error);
        return;
      }

      console.log('Fetched party colors:', data);

      const map = {};
      data.forEach(row => {
        if (row.party && row.color) {
          map[normaliseKey(row.party)] = row.color.trim();
        }
      });
      console.log('Processed party color map:', map);

      setPartyColors(map);
    };

    fetchColors();
  }, []);


  // Log map whenever it changes
  useEffect(() => {
    console.log('Party colors updated:', partyColors);
  }, [partyColors]);

  const getPartyColor = (party) => {
    const key = normaliseKey(party);
    const color = partyColors[key] || '#9ca3af'; // default grey
    console.log('getPartyColor:', { party, key, color });
    return color;

  };

  return (
    <PartyColorContext.Provider value={{ partyColors, getPartyColor }}>
      {children}
    </PartyColorContext.Provider>
  );
};
